
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kereses/[searchTerm]",
      function () {
        return require("private-next-pages/kereses/[searchTerm].tsx");
      }
    ]);
  